/**
 * lhx-video.js — UNIONX 23/08/2026
 *
 * Reproduce los videos de las TARJETAS de colección cuando entran en pantalla, y los pausa
 * cuando salen. El marcado lo pone `snippets/lhx-video-liviano.liquid`.
 *
 * Por qué no es `autoplay` a secas
 * --------------------------------
 * 🪤 El atributo `autoplay` PISA a `preload="none"`: el navegador baja el archivo entero aunque
 *    nadie lo mire. Ese fue exactamente el bug de los 273,95 MB por visita del 08/08.
 *
 * Por qué UN observador y no uno por video
 * ----------------------------------------
 * 🪤 El INP del home ya está en ámbar (260 ms medidos el 21/08). N observadores para N tarjetas
 *    lo empeoran. Uno solo, compartido, con `WeakSet` para no re-observar lo mismo.
 *
 * Por qué hay MutationObserver
 * ----------------------------
 * 🪤 Horizon repinta la grilla al filtrar y al paginar (section-rendering + morph). Sin esto, los
 *    videos que llegan en el repintado nunca se observan y la colección filtrada queda muda.
 */
(function () {
  if (window.__lhxVid) return;
  window.__lhxVid = true;

  var SEL = 'video[data-lhx-vid]';

  function arranca() {
    /* Quien pidió menos movimiento se queda con el póster. El CSS ya lo oculta; acá además
       evitamos crear el observador y gastar CPU. */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(
      function (entradas) {
        for (var i = 0; i < entradas.length; i++) {
          var e = entradas[i];
          var v = e.target;
          if (e.isIntersecting) {
            /* preload sube a 'auto' recién acá: hasta este momento no se bajó ni un byte. */
            if (v.preload === 'none') v.preload = 'auto';
            var p = v.play();
            /* Safari/iOS rechaza la promesa si el gesto no califica. No es un error nuestro:
               se queda el póster, que es exactamente el estado de hoy. */
            if (p && p.catch) p.catch(function () {});
            v.classList.add('lhx-vid--on');
          } else {
            v.pause();
            v.classList.remove('lhx-vid--on');
          }
        }
      },
      { rootMargin: '0px', threshold: 0.5 }
    );

    var vistos = new WeakSet();

    function barrer() {
      var vids = document.querySelectorAll(SEL);
      for (var i = 0; i < vids.length; i++) {
        if (vistos.has(vids[i])) continue;
        vistos.add(vids[i]);
        obs.observe(vids[i]);
      }
    }

    barrer();

    var t = null;
    var mo = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(barrer, 200);
    });
    mo.observe(document.body, { childList: true, subtree: true });

    /* La pestaña oculta no debe seguir gastando red ni batería. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) return;
      var vids = document.querySelectorAll(SEL);
      for (var i = 0; i < vids.length; i++) vids[i].pause();
    });
  }

  /* ──────────────────────────────────────────────────────────────────────────────────────
     El rail: flechas y arrastre.

     Reportado por Martin el 24/08: «no puedo correr los videos para el lado». La pista SÍ
     desplaza (3.040 px de contenido sobre 1.350 visibles) pero la barra está oculta y la rueda
     del mouse mueve la página, no el rail: con mouse no había de dónde agarrarla.

     🥇 Todo por DELEGACIÓN en document, y se registra YA (no dentro del arranque diferido): así
        funciona también en la ficha, donde el rail lo inyecta el morph de las recomendaciones y
        no existe cuando este archivo corre.
     🪤 NO se toca la rueda del mouse. Traducir scroll vertical a horizontal secuestra el scroll
        de la página, y ya nos costó caro el 23/08 con `scroll-snap-stop: always` trabando la
        rueda en el reproductor.
     ────────────────────────────────────────────────────────────────────────────────────── */
  (function railNav() {
    var PISTA = '[data-lhx-rail-pista]';

    function estado(pista) {
      var vp = pista.parentElement;
      if (!vp) return;
      var prev = vp.querySelector('.lhx-rail__flecha--prev');
      var next = vp.querySelector('.lhx-rail__flecha--next');
      var max = pista.scrollWidth - pista.clientWidth;
      /* 🪤 En reposo `scrollLeft` NO vale 0: la pista tiene relleno lateral y el scroll-snap
         engancha en la primera tarjeta, que arranca dentro de ese relleno (medido: 16 px). Con
         el umbral en 0 la flecha izquierda se veía estando al principio. Se ata al relleno
         real en vez de a un número a mano. */
      var borde = parseFloat(getComputedStyle(pista).paddingLeft) || 0;
      if (prev) prev.hidden = pista.scrollLeft <= borde + 4;
      if (next) next.hidden = pista.scrollLeft >= max - 4;
    }

    function todas() {
      var ps = document.querySelectorAll(PISTA);
      for (var i = 0; i < ps.length; i++) estado(ps[i]);
    }

    /* Un "paso" es lo que se ve, menos una tarjeta: siempre queda una de referencia visible. */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-lhx-rail-nav]');
      if (!b) return;
      var vp = b.parentElement;
      var pista = vp && vp.querySelector(PISTA);
      if (!pista) return;
      var card = pista.querySelector('[data-lhx-rail-item]');
      var ancho = card ? card.getBoundingClientRect().width + 16 : 220;
      var paso = Math.max(ancho, pista.clientWidth - ancho);
      pista.scrollBy({ left: paso * Number(b.dataset.lhxRailNav), behavior: 'smooth' });
    });

    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches(PISTA)) estado(t);
    }, true);

    /* Arrastre con el mouse. 🪤 Si no se distingue arrastrar de hacer clic, soltar el botón
       abre el reproductor del video sobre el que quedó el cursor. Por eso el umbral de 6 px
       y el clic suprimido una sola vez. */
    var arr = null;
    document.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 || e.pointerType !== 'mouse') return;
      var pista = e.target.closest && e.target.closest(PISTA);
      if (!pista) return;
      arr = { pista: pista, x: e.clientX, inicio: pista.scrollLeft, movido: false };
    });
    document.addEventListener('pointermove', function (e) {
      if (!arr) return;
      var d = e.clientX - arr.x;
      if (!arr.movido && Math.abs(d) < 6) return;
      if (!arr.movido) { arr.movido = true; arr.pista.classList.add('lhx-arrastrando'); }
      arr.pista.scrollLeft = arr.inicio - d;
    });
    document.addEventListener('pointerup', function () {
      if (!arr) return;
      var a = arr; arr = null;
      a.pista.classList.remove('lhx-arrastrando');
      if (!a.movido) return;
      document.addEventListener('click', function tragar(ev) {
        ev.stopPropagation(); ev.preventDefault();
      }, { capture: true, once: true });
    });

    if (document.readyState !== 'loading') todas();
    else document.addEventListener('DOMContentLoaded', todas, { once: true });
    window.addEventListener('load', todas, { once: true });
    window.addEventListener('resize', todas);
    new MutationObserver(todas).observe(document.documentElement, { childList: true, subtree: true });
  })();

  /* Diferido a propósito: no compite con el LCP. Mismo criterio con que se difirió el chat de
     Rayen el 21/08 (LCP del home 2.523 ms, 23 ms sobre el umbral: no hay margen que regalar). */
  if (document.readyState === 'complete') {
    setTimeout(arranca, 1200);
  } else {
    window.addEventListener('load', function () { setTimeout(arranca, 1200); }, { once: true });
  }
})();
